import { render, staticRenderFns } from "./VStatus.vue?vue&type=template&id=08be2b9f&"
import script from "./VStatus.vue?vue&type=script&lang=ts&"
export * from "./VStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports